// eslint-disable-next-line no-unused-vars
export default (state, message) => {}
